import {Route} from "react-router-dom";
import Login from "../components/login";
import {Layout} from "../components/layout";
import SignUp from "../components/signup";
import ForgotPassword from "../components/forgotPassword";
import ResetPassword from "../components/resetPassword";
import DeleteAccountRequest from "../components/deleteAccountRequest";
import Dashboard from "../pages/dashboard/dashboard";
import Otp from "../components/otp";
import TermsCondition from "../components/TermsCondition";
import PrivacyPolicy from "../components/PrivacyPolicy";

const AdminRoutes = (
        <>
            <Route >
                <Route path="/" element={<Login/>} exact/>
                <Route path="/login" element={<Login/>} exact/>
                <Route path="/signup" element={<SignUp/>} exact/>
                <Route path="/forgot-password" element={<ForgotPassword/>} exact/>
                <Route path="/reset-password" element={<ResetPassword/>}/>
                <Route path="/delete-account-request" element={<DeleteAccountRequest/>}/>
                <Route path="/otp-verification" element={<Otp/>}/>

                <Route path="/privacy-policy" element={<PrivacyPolicy/>} exact/>
                <Route path="/terms-conditions" element={<TermsCondition/>} exact/>
            </Route>

            {/*protected routes of user*/}

            <Route >
                <Route path="/" element={<Layout/>}>
                    <Route path="/dashboard" element={<Dashboard/>} exact/>
                </Route>
            </Route>
        </>
    )
;

export default AdminRoutes;